import { BookingModality } from '../models/types';
import { getPublicAssetUrl } from './publicAssets';
import { getShopImageFolderName } from './roomImages';

const MODALITY_IMAGE_FILES: Record<BookingModality, string> = {
    flexible: 'Flexible.webp',
    asistida: 'Asistida.webp',
    todo_resuelto: 'TodoResuelto.webp',
};

export function getGeneralModalityImageUrl(modalityId: BookingModality): string {
    return getPublicAssetUrl(`img/modalities/${MODALITY_IMAGE_FILES[modalityId]}`);
}

export function getModalityImageUrl(
    modalityId: BookingModality,
    shopId?: number,
    shopName?: string
): string {
    const fileName = MODALITY_IMAGE_FILES[modalityId];
    const folderName =
        shopId != null ? getShopImageFolderName(shopId, shopName) : null;

    if (folderName) {
        return getPublicAssetUrl(`img/modalities/${folderName}/${fileName}`);
    }

    return getGeneralModalityImageUrl(modalityId);
}
